<template>
  <div class="tab-panel-content">
    <div class="card">
      <div class="card-title"><span class="mdi mdi-timer-outline"></span> Flink Job 轮询频率</div>
      <div class="cfg-grid">
        <div v-for="cfg in pollIntervals" :key="cfg.job" class="cfg-item">
          <div class="cfg-head">
            <div class="left"><span class="cfg-name">{{ cfg.name }}</span></div>
            <span style="font-size: 11px; color: var(--text-muted)">默认 {{ cfg.defaultVal }}s</span>
          </div>
          <div class="cfg-row">
            <el-slider
              v-model="cfg.interval"
              :min="5"
              :max="300"
              :step="5"
              :marks="{ 10: '10s', 30: '30s', 60: '1m', 120: '2m' }"
              :format-tooltip="formatSecondsTooltip"
              :disabled="!canEditPollInterval"
            />
            <div class="cfg-val">{{ cfg.interval }}<span class="cfg-unit">s</span></div>
          </div>
          <div class="cfg-hint">{{ cfg.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAlarmConfig } from '../useAlarmConfig'
import { checkPermi } from '@/utils/permission'
import { computed } from 'vue'

const { pollIntervals, formatSecondsTooltip } = useAlarmConfig()
const canEditPollInterval = computed(() => checkPermi(['ops:alarmConfig:pollInterval']))
</script>

<style scoped lang="scss">
.card {
  background: var(--card-bg);
  border-radius: 12px;
  border: 1px solid #fff;
  box-shadow: var(--shadow-card);
  padding: 20px 24px;
  margin-bottom: 16px;
  backdrop-filter: blur(6px);
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-title .mdi {
  color: var(--primary);
}

.cfg-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 12px;
}

.cfg-item {
  background: color-mix(in srgb, #ffffff 88%, var(--primary-faint));
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px 20px;
  transition: box-shadow 0.2s ease;
}

.cfg-item:hover {
  box-shadow: var(--shadow-card);
}

.cfg-item .cfg-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.cfg-item .cfg-head .left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cfg-item .cfg-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.cfg-item .cfg-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cfg-item .cfg-row :deep(.el-slider) {
  flex: 1;
}

.cfg-item .cfg-val {
  min-width: 72px;
  text-align: right;
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
}

.cfg-item .cfg-unit {
  font-size: 12px;
  color: var(--text-muted);
  font-weight: 400;
}

.cfg-item .cfg-hint {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 18px;
}

@media (prefers-reduced-motion: reduce) {
  .cfg-item {
    transition: none;
  }
}
</style>
